var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dt',{staticClass:"text-sm leading-5 font-medium text-gray-500"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('dd',{staticClass:"mt-1 text-sm leading-5 text-gray-900"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }